import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import PrimaryButton from "../generic/PrimaryButton";

import { ReactComponent as Circle1 } from "../../assets/icons/circleAnimations/circle1.svg";
import { ReactComponent as Circle2 } from "../../assets/icons/circleAnimations/Circle2.svg";
import { ReactComponent as Circle3 } from "../../assets/icons/circleAnimations/Circle3.svg";
import { ReactComponent as Circle4 } from "../../assets/icons/circleAnimations/Circle4.svg";
import { ReactComponent as Circle5 } from "../../assets/icons/circleAnimations/Circle5.svg";
import { ReactComponent as AssetTop } from "../../assets/icons/circleAnimations/CircleAssetTop.svg";
import { ReactComponent as AssetBottom } from "../../assets/icons/circleAnimations/CircleAssetBottom.svg";
import { ReactComponent as AssetRight } from "../../assets/icons/circleAnimations/CircleAssetRight.svg";
import { ReactComponent as AssetLeft } from "../../assets/icons/circleAnimations/CircleAssetLeft.svg";
import { ReactComponent as AssetCenter } from "../../assets/icons/circleAnimations/CircleAssetCenter.svg";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import OutlinedButton from "../generic/OutlinedButton";
import { ReactComponent as GridDecoration } from "../../assets/decorations/decorationIntro.svg";

const Fold1 = () => {

  return (
    <FullPageContainer >
      <Container id="fold1Id">
        <TextWrapper>
          <Title>App Growth. Solved.</Title>
          <Subtitle>
            Track campaigns, guide users to content, boost engagement, and
            optimize ad performance with smart links and attribution.
          </Subtitle>
          <Line>

            <PrimaryButton
              text={"Get Started"}
              bgVariant={lightThemeColors.background}
              styled={{ color: lightThemeColors.darkColor }}
              onClick={() =>
                window.open("https://app.grovs.io/register", "_blank")
              }
            />
            <Link style={{ textDecoration: "none" }} to={"/contact"}>
              <OutlinedButton
                text={"Request a demo"}
                variant={lightThemeColors.lightColor}
              />
            </Link>
          </Line>
        </TextWrapper>

        <DecorationWrapper
          as={motion.div}
          initial={{ rotate: 0 }}
          animate={{ rotate: 360 }}
          transition={{
            duration: 20,
            repeat: Infinity,
            repeatType: "loop",
            type: "tween",
            ease: "linear",
          }}
        >
          <motion.div
            style={{
              position: "absolute",
              width: "100%",
            }}
          >
            <Circle5 />
          </motion.div>
          <motion.div
            style={{
              position: "absolute",
              width: "75%",
            }}
          >
            <Circle4 />
          </motion.div>
          <motion.div
            style={{
              position: "absolute",
              width: "60%",
            }}
          >
            <Circle3 />
          </motion.div>
          <motion.div
            style={{
              width: "100%",
              maxWidth: "55%",
            }}
          >
            <Circle2 />
          </motion.div>

          <motion.div
            style={{
              position: "absolute",
              width: "40%",
            }}
          >
            <Circle1 />
          </motion.div>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 20,
              repeat: Infinity,
              repeatType: "loop",
              type: "tween",
              ease: "linear",
            }}
            style={{
              position: "absolute",
              top: "10%",
              width: "60px",
            }}
          >
            <AssetTop />
          </motion.div>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 20,
              repeat: Infinity,
              repeatType: "loop",
              type: "tween",
              ease: "linear",
            }}
            style={{
              position: "absolute",
              bottom: "10%",
              width: "60px",
            }}
          >
            <AssetBottom />
          </motion.div>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 20,
              repeat: Infinity,
              repeatType: "loop",
              type: "tween",
              ease: "linear",
            }}
            style={{
              position: "absolute",
              right: "10%",
              width: "60px",
            }}
          >
            <AssetRight />
          </motion.div>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 20,
              repeat: Infinity,
              repeatType: "loop",
              type: "tween",
              ease: "linear",
            }}
            style={{
              position: "absolute",
              left: "10%",
              width: "60px",
            }}
          >
            <AssetLeft />
          </motion.div>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: -360 }}
            transition={{
              duration: 20,
              repeat: Infinity,
              repeatType: "loop",
              type: "tween",
              ease: "linear",
            }}
            style={{
              position: "absolute",
              width: "80px",
            }}
          >
            <AssetCenter />
          </motion.div>
        </DecorationWrapper>
      </Container>
      <BlurContainer>
        <BlurCircle />
      </BlurContainer>
      <GridDecotrationWrapper>
        <GridDecoration />
      </GridDecotrationWrapper>
    </FullPageContainer>
  );
};

export default Fold1;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.landingPagePrimaryBackground};
  position: relative;
  overflow: hidden;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;
padding:150px 100px 80px;
  gap: 40px;
  position: relative;
  @media (max-width: 990px) {
    flex-direction: column; 
padding:80px 20px 60px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 48px;
  font-weight: 700;
  line-height: 50px;
  text-align: left;
  z-index: 3;
  span {
    color: rgba(21, 49, 91, 0.2);
  }

  @media (max-width: 990px) {
    font-size: 35px;
    line-height: 40px;
    text-align: center;
  }
`;

const Subtitle = styled.h2`
  color: ${lightThemeColors.lightColor};
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 0px;
  max-width: 700px;
  z-index: 3;

  @media (max-width: 990px) {
    text-align: center;
  }
`;

const DecorationWrapper = styled.div`

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 450px;
  min-width: 450px;
  max-height: 450px;
  max-width: 450px;

  margin-left: auto;
  z-index:3;

  svg {
    display: flex;
    height: 100%;
    width: 100%;
  }

  @media (max-width: 990px) {
    margin-left: unset;
  }

  @media (max-width: 550px) {
    display: none;
  }
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  z-index: 1;
  @media (max-width: 990px) {
    align-items: center;
  }
`;
const Line = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
z-index:3;
`;
const BlurCircle = styled.div`
  width: 700px;
  height: 100%;
  border-radius: 50%;
  background: rgba(91, 104, 223, 1);
  will-change: filter;
  filter: blur(120px);
  -webkit-filter: blur(120px);;
  left: -20px;
  opacity: 0.5;
  position: absolute;
`;


const GridDecotrationWrapper = styled.div`
  position: absolute;
  width: 100%;

  z-index: 1;
  svg {
    display: flex;
    margin-left: auto;
    margin-right: auto;
  }
`;

const BlurContainer = styled(Container)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
`;
